export default {
  delete_success: 'Oferta została pomyślnie usunięta',
  delete_failed: 'Usunięcie oferty nie powiodło się',
  delete_confirm_title: 'Czy na pewno chcesz usunąć tę ofertę?',
  delete_last_day_confirm_title: 'Usunięcie ostatniego pozostałego dnia spowoduje usunięcie tej oferty. Czy na pewno?',
  confirm: 'Potwierdź',
  cancel: 'Anuluj',
  qualifying_items: 'Kwalifikujące się pozycje',
  free_items: 'Darmowe pozycje',
  all_day: 'Cały dzień',
  starts_on: 'Rozpoczyna się {{date}}',
  ends_on: 'Kończy się {{date}}',
  ends_when_deleted: 'Kończy się po usunięciu',
  off: '{{amount}} zniżki',
  min_spend_value: 'Min. wydatek: {{amount}}',
};
